var _circle, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccessEntryIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 81,
    viewBox: "0 0 90 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 58.5,
    cy: 31.5,
    r: 31.5,
    fill: "#D0FFF3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.5326 26.8982H15.7624C12.3306 26.8982 9.53857 29.6898 9.53857 33.1221C9.53857 34.0445 10.2864 34.7919 11.2084 34.7919C12.1304 34.7919 12.8783 34.0445 12.8783 33.1221C12.8783 31.5315 14.1722 30.2379 15.7624 30.2379H38.5336C40.1242 30.2379 41.4181 31.5315 41.4181 33.1221V74.1093C41.4181 75.6999 40.1242 76.9935 38.5336 76.9935H15.7624C14.1722 76.9935 12.8783 75.6999 12.8783 74.1093C12.8783 73.1869 12.1304 72.4394 11.2084 72.4394C10.2864 72.4394 9.53857 73.1869 9.53857 74.1093C9.53857 77.5416 12.3306 80.3332 15.7624 80.3332H38.5336C41.9655 80.3332 44.7578 77.5416 44.7578 74.1093L44.7574 33.1221C44.7574 29.6898 41.9655 26.8982 38.5332 26.8982H38.5326Z",
    fill: "#212121",
    stroke: "#212121",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5815 61.5431C13.9294 62.1956 13.9294 63.2526 14.5819 63.9043C14.9079 64.2303 15.3352 64.3935 15.7624 64.3935C16.1897 64.3935 16.6174 64.2303 16.9434 63.9043L26.0519 54.7958C26.6157 54.232 26.702 53.3488 26.2587 52.6861C26.1916 52.5861 26.1151 52.4955 26.0315 52.4142C25.605 51.9885 16.9435 43.327 16.9435 43.327C16.2914 42.6753 15.234 42.6741 14.5819 43.327C13.9295 43.9787 13.9295 45.0361 14.5816 45.6882L20.8392 51.9458H2.09977C1.17775 51.9458 0.429932 52.6932 0.429932 53.6156C0.429932 54.538 1.17775 55.2855 2.09977 55.2855H20.8392L14.5815 61.5431Z",
    fill: "#212121",
    stroke: "#212121",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66.0623 27L57.5318 35.5304L53 30.7079",
    stroke: "#00DEA3",
    strokeWidth: 2.54206,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessEntryIcon);
export default __webpack_public_path__ + "static/media/success-entry-icon.dbf34a2f8e490ff6ad5c5e2d1ba52975.svg";
export { ForwardRef as ReactComponent };